import { ActivatedRouteSnapshot } from '@angular/router';

export const getParentPath = (route: ActivatedRouteSnapshot): string => {
  const parent = route.pathFromRoot
    .flatMap(r => r.url)
    .map(s => s.path)
    .filter(Boolean)
    .slice(0, -1)
    .join('/');

  return parent ? `/${parent}` : '';
};
